import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import ReactSelect from '../../../common/ReactSelect';
import DatePicker from "react-datepicker";
import { getMasterConfig } from '@src/store/slices/common';
import { getSfaRoleUserList } from '@src/store/slices/agency';
import { useLanguage } from "@src/context/LanguageContext";
import { PAGE_NUMBER, STATUS_SUCCESS } from '@src/config/constant';

const AgencyListTopFilter = (props: any) => {
    const dispatch: any = useDispatch();

    const [selectedFilters, setSelectedFilters] = useState<any>({});
    const [reportingToRole, setReportingToRole] = useState<any>([]);
    const [reportingTo, setReportingTo] = useState<any>([]);
    const commonState = useSelector((state: any) => state.common)
    const {translations} = useLanguage();

    useEffect(() => {
        setSelectedFilters(props.resetSelectedFilters);
    }, [props.resetSelectedFilters])

    const formatDateToYMD = (date: any): string => {
        const selectedDate = new Date(date);
        const year = selectedDate.getFullYear();
        const month = String(selectedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(selectedDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleChangeDateType = (selectedOption: any, key: string) => {
        let updatedMoreFilters: any = selectedFilters;
        if(key === "created_at"){
            const formattedDate = formatDateToYMD(selectedOption);
            updatedMoreFilters = {...updatedMoreFilters, created_at:formattedDate};
        }else if (key === "approval_date"){
            const formattedDate = formatDateToYMD(selectedOption);
            updatedMoreFilters = {...updatedMoreFilters, approval_date:formattedDate};
        }else{
            updatedMoreFilters = selectedOption['value'];
        }
        setSelectedFilters(updatedMoreFilters);
    };

    const getSfaRoleUser = (params : any,isLoading = true) => {
        getSfaRoleUserList(params).then((res: any) => {
            if (res.status === STATUS_SUCCESS) {
                setReportingTo(res.data);
                setSelectedFilters((prevState: any) => {
                    const updatedState = { ...prevState };
                    delete updatedState.reporting_to_name;
                    delete updatedState.reporting_to_name_label;
                    return updatedState;
                });
            }
        }).catch((err:any) => console.log(err));
    }



    /**
     * CHANGE HANDLER
     * @param selectedOption 
     * @param key 
     */
    const handleChange = (selectedOption: any, key: string) => {
        setSelectedFilters((prevFilters: any) => {
            let updatedFilters = { ...prevFilters };
    
            if (key === "searchKeyword") {
                updatedFilters.searchKeyword = selectedOption.target.value || undefined;
            } else {
                updatedFilters[key] = selectedOption ? selectedOption.value : null;
            }
    
            if (key === "reporting_to_role" && selectedOption) {
                updatedFilters.reporting_to_role_label = selectedOption.label;
                let role_id: number = +selectedOption.value;
                getSfaRoleUser({ role_id: role_id });
            }
            if(key === "reporting_to_name"){
                updatedFilters.reporting_to_name_label = selectedOption.label;
            }
            return updatedFilters;
        });
    };
    

    /**
     * UPDATE OVERALL FILTER
     * @param filterParams 
     */
    const updateFiltersData = (filterParams: any) => {
        let updatedFilters = {};
        setSelectedFilters(updatedFilters);
        // dispatch(leadListFilters(updatedFilters));
        props.resetSort();
    }

     /**
     * FILTER SEARCH HANDLER
     */
     const onFilterSearch = () => {
        props.submitHandler({ ...selectedFilters, page_number: PAGE_NUMBER});
    }

    /**
     * FILTER RESET HANDLER
     */
    const onFilterReset = () => {
        updateFiltersData({type:'reset'});
    }

    useEffect(() => {
        if (!commonState?.sfa_roles?.length) {
            dispatch(getMasterConfig()).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    const transformedRoles = res.data.sfa_roles.map((role: any) => ({
                        ...role,
                        label: role.description 
                    }));
                    setReportingToRole(transformedRoles); 
                }
            })
        } else {
            const transformedRoles = commonState.sfa_roles.map((role: any) => ({
                ...role,
                label: role.description 
            }));
            setReportingToRole(transformedRoles);
        }
        // eslint-disable-next-line
    }, []);

    // useEffect(()=>{
    //      setSelectedFilters((prevFilters:any) => {
    //         const updatedFilters = { ...prevFilters };
    //         delete updatedFilters.reporting_to_name;
    //         return updatedFilters;
    //     });
    //     // eslint-disable-next-line
    // },[selectedFilters?.reporting_to_role])


    return (
        <React.Fragment>
            <div className="lead-list-filter">
                <div className="filter-filed-form">
                    <fieldset className="search-bx">
                        <div className="material" title={translations.RuleEngineAgency?.['Search_By_agency_name'] || translations.commonMsg?.loading}>
                            <input id="" type="text" placeholder={translations.RuleEngineAgency?.['Search_By_agency_name'] || translations.commonMsg?.loading} name="RoleName" className="form-input" onChange={(e) => handleChange(e, 'searchKeyword')} value={selectedFilters?.searchKeyword || ""} />
                            <i className="ic-search"></i>
                        </div>
                    </fieldset>
                    <fieldset className='multi-datepicker'>
                        <div className="datepicker">
                            <DatePicker
                                value={selectedFilters?.created_at || ""}
                                onChange={(e: any) => handleChangeDateType(e, 'created_at')}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText={translations.RuleEngineAgency?.['Created_Date'] || translations.commonMsg?.loading}
                            />
                            <label title={'Created Date'} data-label="Created Date" className={`form-label datepick-heading`}></label>
                        </div>
                    </fieldset>
                    <fieldset className='multi-datepicker'>
                        <div className="datepicker">
                            <DatePicker
                                value={selectedFilters?.approval_date || ""}
                                onChange={(e: any) => handleChangeDateType(e, 'approval_date')}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText={translations.RuleEngineAgency?.['Approval_Date'] || translations.commonMsg?.loading}
                            />
                            <label title={'Approval Date'} data-label="Approval Date" className={`form-label datepick-heading`}></label>
                        </div>
                    </fieldset>
                    <ReactSelect
                        options={reportingToRole || []}
                        isSelectAll={true}
                        value={selectedFilters.reporting_to_role ? reportingToRole?.find((option:any) => option.value === selectedFilters.reporting_to_role) : null}
                        handleChange={(e: any) => handleChange(e, "reporting_to_role")}
                        placeholder={translations.RuleEngineAgency?.['Reporting_to_Role'] || translations.commonMsg?.loading}
                        isClearable={false}
                    />
                    <label data-label={translations.RuleEngineAgency?.['Reporting_to_Role'] || translations.commonMsg?.loading} className="form-label"></label>
                    <ReactSelect
                        options={reportingTo ?? []}
                        isSelectAll={true}
                        value={selectedFilters.reporting_to_name ? reportingTo?.find((option: any) => option.value === selectedFilters.reporting_to_name) : null}
                        // value={reportingTo?.find((option:any) => option.value === selectedFilters.reporting_to_name)}
                        handleChange={(e: any) => handleChange(e, "reporting_to_name")}
                        placeholder={translations.RuleEngineAgency?.['Reporting_to_Name'] || translations.commonMsg?.loading}
                        isClearable={false}
                    />
                    <label data-label={translations.RuleEngineAgency?.['Reporting_to_Name'] || translations.commonMsg?.loading} className="form-label"></label>
                    <div className="btn-submit-reset top-btn-none">
                        <button className="btn-primary" onClick={onFilterSearch}>{translations.commonMsg?.['search'] || translations.commonMsg?.loading}</button>
                        <button className="btn-reset" onClick={onFilterReset}>{translations.commonMsg?.['reset'] || translations.commonMsg?.loading}</button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AgencyListTopFilter;
